/**
 * Stable browser aliases retained for existing users and bookmarks.
 *
 * Production auto scheduling intentionally does not claim `/auto-scheduling`:
 * that route remains a personnel-scheduling solver alias.
 */
export const MVP_REDIRECTS: Record<string, string> = {
  '/batch-management': '/batch-management-v4',
  '/task-pool': '/operations-overview',
  '/schedule-overview': '/operations-overview',
  '/special-shift-windows': '/personnel-scheduling',
  '/auto-scheduling': '/solver-v4',
  '/modular-scheduling': '/solver-v4',
  '/scheduling-v3': '/solver-v4',
  '/operation-constraints': '/operations',
  '/system-monitor': '/operations-overview',
  '/system-settings': '/operations-overview',
  '/auto-scheduling-debug': '/solver-v4',
  '/platform-overview': '/operations-overview',
  '/resource-center': '/organization-workbench',
  '/project-planning-center': '/batch-management-v4',
  '/maintenance-windows': '/batch-management-v4',
  '/business-rules-center': '/operations',
  '/platform-run-monitor': '/solver-v4',
  '/roster/exceptions': '/solver-v4',
};
